// File: src/api/posts.js

import client from './client';
import { getUserId, getAuthCode } from './authStorage';

/**
 * Fetch paginated posts for the admin dashboard.
 * @param {number} page 
 * @param {number} perPage 
 * @returns {Promise<{ pagination: object, data: Array }>}
 */
export async function fetchPosts(page = 1, perPage = 20) {
  const user_id   = getUserId();
  const auth_code = getAuthCode();

  const payload = { user_id, auth_code, page, per_page: perPage };
  const { data: res } = await client.post('/fetch_posts.php', payload);

  if (res.status !== 200) {
    throw new Error(res.message || 'Failed to fetch posts');
  }

  return {
    pagination: res.pagination,
    data:       res.data
  };
}
